module.exports = __webpack_public_path__ + "static/media/3.8dd39572.svg";